// 🔑 PROGRESS AS 8 SHORT SEGMENTS (Jesse, 2026-10-19): completed, current, upcoming — instead of one long bar. Used
// under the step title and, smaller, in the menu's current-step card.
import React from 'react';
import { TOTAL_STEPS } from '../../constants/guidedFlowSteps';

// Jesse, 2026-10-21: completed Doorly blue, current Doorly yellow, upcoming grey (was lime / near-black).
const COLOURS = { done: '#3a6ad9', current: '#fffd5b', upcoming: '#e5e7eb' };

// 🔑 `total` and `valueText` (2026-10-28, LO plan v7): DoorlyPro's submission flow uses the same segments with its own
// count, and never says "Step n of 8" (it never names the borrower's steps). The borrower's flow passes neither.
export default function GuidedProgress({ step, compact = false, total = TOTAL_STEPS, valueText = null }) {
  const n = Number(step) || 1;
  return (
    <div data-testid="guided-progress" role="progressbar" aria-label="Application progress"
      aria-valuemin={1} aria-valuemax={total} aria-valuenow={n} aria-valuetext={valueText || `Step ${n} of ${total}`}
      style={{ display: 'flex', gap: compact ? 3 : 4 }}>
      {Array.from({ length: total }, (_, i) => {
        const state = i + 1 < n ? 'done' : i + 1 === n ? 'current' : 'upcoming';
        return <div key={i} data-segment={state} style={{ flex: 1, height: compact ? 4 : 6, borderRadius: 3, background: COLOURS[state] }} />;
      })}
    </div>
  );
}
